<script>
import { company } from '@site/data/company'
import { CONTACT } from '@site/data/contact'
import AppIcon from '@site/components/common/AppIcon.vue'

export default {
  name: 'AboutView',
  components: { AppIcon },
  data() {
    return {
      company,
      CONTACT,
      values: [
        { icon: 'check', title: '进销存', desc: '让货物与管理更清晰' },
        { icon: 'chart', title: '数据', desc: '让经营决策更有据' },
        { icon: 'user', title: '营销', desc: '让会员与生意更活跃' },
      ],
    }
  },
}
</script>

<template>
  <div class="about-page">
    <section class="about-hero">
      <div class="container">
        <span class="about-hero__eyebrow">关于我们</span>
        <h1>做中小商户管理生意的好帮手</h1>
        <p>江苏宜航信息技术有限公司，一站式零售收银与门店管理系统服务商</p>
      </div>
    </section>

    <section class="section section--white">
      <div class="container">
        <div class="about-grid">
          <div class="about-intro reveal">
            <span class="section-eyebrow">公司简介</span>
            <h2>{{ company.name }}</h2>
            <p>{{ company.intro }}</p>
          </div>
          <div class="about-values reveal">
            <div v-for="v in values" :key="v.title" class="about-value">
              <div class="icon-badge"><AppIcon :name="v.icon" /></div>
              <div>
                <h3>{{ v.title }}</h3>
                <p>{{ v.desc }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section section--light">
      <div class="container">
        <div class="section-head reveal">
          <span class="section-eyebrow">使命与承诺</span>
          <h2>帮助商户提升经营效率</h2>
        </div>
        <div class="grid grid--2">
          <div class="card reveal">
            <div class="icon-badge"><AppIcon name="star" /></div>
            <h3 style="margin: 14px 0 6px">使命 / 愿景</h3>
            <p style="color:#5b6472">{{ company.mission }}</p>
          </div>
          <div class="card reveal">
            <div class="icon-badge"><AppIcon name="shield" /></div>
            <h3 style="margin: 14px 0 6px">服务承诺</h3>
            <p style="color:#5b6472">{{ company.service }}</p>
          </div>
        </div>
      </div>
    </section>

    <section class="section section--white">
      <div class="container">
        <div class="section-head reveal">
          <span class="section-eyebrow">联系我们</span>
          <h2>欢迎到访 / 随时咨询</h2>
        </div>
        <div class="about-contact reveal">
          <div class="about-contact__item">
            <span class="chip chip--brand">地址</span>
            <p>{{ CONTACT.address }}</p>
          </div>
          <div class="about-contact__item">
            <span class="chip chip--brand">服务时间</span>
            <p>{{ CONTACT.serviceHours }}</p>
          </div>
          <div class="about-contact__item">
            <span class="chip chip--brand">电话</span>
            <p>{{ CONTACT.phone1.name }} {{ CONTACT.phone1.tel }}</p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>


<style lang="scss" scoped>
.about-page { padding-top: 72px; }

.about-hero {
  background: $gradient-dark;
  color: $color-white;
  text-align: center;
  padding: 104px 0 88px;
  &__eyebrow { color: rgba(255,255,255,0.62); font-weight: $weight-semibold; letter-spacing: 0.12em; font-size: 13px; text-transform: uppercase; }
  h1 { color: $color-white; font-size: 48px; font-weight: $weight-black; margin: 16px 0 14px; letter-spacing: -0.02em; }
  p { color: rgba(255,255,255,0.72); font-size: 18px; max-width: 640px; margin: 0 auto; }
}

.about-grid {
  display: grid;
  grid-template-columns: 1.2fr 1fr;
  gap: 40px;
  align-items: start;
}

.about-intro {
  h2 { font-size: 30px; margin-bottom: 16px; }
  p { color: $color-text-muted; line-height: 1.8; font-size: 17px; }
}

.about-values {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.about-value {
  display: flex;
  gap: 14px;
  align-items: flex-start;
  padding: 16px;
  background: $color-bg-light;
  border-radius: $radius-md;
  h3 { font-size: $font-card; margin-bottom: 2px; }
  p { color: $color-text-muted; font-size: 14px; }
}

.about-contact {
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-width: 620px;
  &__item {
    display: flex;
    align-items: flex-start;
    gap: 16px;
    padding: 16px 20px;
    background: $color-bg-light;
    border-radius: $radius-md;
    p { color: $color-text; line-height: 1.6; }
  }
}

@media (max-width: $bp-sm) {
  .about-hero h1 { font-size: 32px; }
  .about-grid { grid-template-columns: 1fr; gap: 24px; }
}
</style>



// WEBPACK FOOTER //
// src/site/views/AboutView.vue